import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-chall-approval',
  templateUrl: './payment-chall-approval.component.html',
  styleUrls: ['./payment-chall-approval.component.css']
})
export class PaymentChallApprovalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/recovery/payment-chall-approval/payment-chall-approval.component.ts